import { ProductlistViewProduct } from 'models/ProductlistViewProduct';
import { ProductCard } from 'components/Shared/Product/themes/BGH/productCard';
import { SrcSet } from 'components/Shared/Image/SrcSet';
import { forwardRef, Ref } from 'react';

interface OwnProps {
  product: ProductlistViewProduct;
  isListView?: boolean;
  isSponsored?: boolean;
  maxVariants?: number;
  isLazy?: boolean;
  heroDisplay?: boolean;
  onLinkClick?: () => void;
}

const MOBILE_WIDTH = 181;
const DESKTOP_WIDTH = 358;
const IMAGE_MARGIN = 2;

const picture = {
  height: DESKTOP_WIDTH + IMAGE_MARGIN,
  width: DESKTOP_WIDTH + IMAGE_MARGIN
};

const sizes: { [key: string]: SrcSet } = {
  default: {
    viewWidth: MOBILE_WIDTH,
    width: MOBILE_WIDTH,
    height: MOBILE_WIDTH
  },
  medium: {
    viewWidth: DESKTOP_WIDTH,
    width: DESKTOP_WIDTH,
    height: DESKTOP_WIDTH
  }
};

export const ProductListCard = forwardRef(
  (
    { product, isListView, isSponsored, maxVariants, isLazy, heroDisplay, onLinkClick }: OwnProps,
    ref?: Ref<HTMLDivElement>
  ) => (
    <ProductCard
      isLazy={isLazy}
      maxVariants={maxVariants}
      isListView={isListView}
      isSponsored={isSponsored}
      key={product.ticket}
      picture={picture}
      ref={ref}
      customSizes={sizes}
      heroDisplay={heroDisplay}
      onLinkClick={onLinkClick}
      {...product}
    />
  )
);
